export enum RecommendedVendorSelectionMode {
  AUTO_SELECTED = 'AUTO_SELECTED',
  CUSTOMER_SELECTION = 'CUSTOMER_SELECTION',
  FIXED_SELECTION_WITH_REPLACEMENT = 'FIXED_SELECTION_WITH_REPLACEMENT',
}
